import { createLocationOptionsGetter } from '../LocationOptionHelpers/LocationOptionHelpers';

interface StateType {
    name: string;
    isoCode: string;
}

const stateMap: Record<string, StateType> = {
    'AL': {
        name: 'Alabama',
        isoCode: 'AL'
    },
    'AK': {
        name: 'Alaska',
        isoCode: 'AK'
    },
    'AZ': {
        name: 'Arizona',
        isoCode: 'AZ'
    },
    'AR': {
        name: 'Arkansas',
        isoCode: 'AR'
    },
    'CA': {
        name: 'California',
        isoCode: 'CA'
    },
    'CO': {
        name: 'Colorado',
        isoCode: 'CO'
    },
    'CT': {
        name: 'Connecticut',
        isoCode: 'CT'
    },
    'DE': {
        name: 'Delaware',
        isoCode: 'DE'
    },
    'FL': {
        name: 'Florida',
        isoCode: 'FL'
    },
    'GA': {
        name: 'Georgia',
        isoCode: 'GA'
    },
    'HI': {
        name: 'Hawaii',
        isoCode: 'HI'
    },
    'ID': {
        name: 'Idaho',
        isoCode: 'ID'
    },
    'IL': {
        name: 'Illinois',
        isoCode: 'IL'
    },
    'IN': {
        name: 'Indiana',
        isoCode: 'IN'
    },
    'IA': {
        name: 'Iowa',
        isoCode: 'IA'
    },
    'KS': {
        name: 'Kansas',
        isoCode: 'KS'
    },
    'KY': {
        name: 'Kentucky',
        isoCode: 'KY'
    },
    'LA': {
        name: 'Louisiana',
        isoCode: 'LA'
    },
    'ME': {
        name: 'Maine',
        isoCode: 'ME'
    },
    'MD': {
        name: 'Maryland',
        isoCode: 'MD'
    },
    'MA': {
        name: 'Massachusetts',
        isoCode: 'MA'
    },
    'MI': {
        name: 'Michigan',
        isoCode: 'MI'
    },
    'MN': {
        name: 'Minnesota',
        isoCode: 'MN'
    },
    'MS': {
        name: 'Mississippi',
        isoCode: 'MS'
    },
    'MO': {
        name: 'Missouri',
        isoCode: 'MO'
    },
    'MT': {
        name: 'Montana',
        isoCode: 'MT'
    },
    'NE': {
        name: 'Nebraska',
        isoCode: 'NE'
    },
    'NV': {
        name: 'Nevada',
        isoCode: 'NV'
    },
    'NH': {
        name: 'New Hampshire',
        isoCode: 'NH'
    },
    'NJ': {
        name: 'New Jersey',
        isoCode: 'NJ'
    },
    'NM': {
        name: 'New Mexico',
        isoCode: 'NM'
    },
    'NY': {
        name: 'New York',
        isoCode: 'NY'
    },
    'NC': {
        name: 'North Carolina',
        isoCode: 'NC'
    },
    'ND': {
        name: 'North Dakota',
        isoCode: 'ND'
    },
    'OH': {
        name: 'Ohio',
        isoCode: 'OH'
    },
    'OK': {
        name: 'Oklahoma',
        isoCode: 'OK'
    },
    'OR': {
        name: 'Oregon',
        isoCode: 'OR'
    },
    'PA': {
        name: 'Pennsylvania',
        isoCode: 'PA'
    },
    'RI': {
        name: 'Rhode Island',
        isoCode: 'RI'
    },
    'SC': {
        name: 'South Carolina',
        isoCode: 'SC'
    },
    'SD': {
        name: 'South Dakota',
        isoCode: 'SD'
    },
    'TN': {
        name: 'Tennessee',
        isoCode: 'TN'
    },
    'TX': {
        name: 'Texas',
        isoCode: 'TX'
    },
    'UT': {
        name: 'Utah',
        isoCode: 'UT'
    },
    'VT': {
        name: 'Vermont',
        isoCode: 'VT'
    },
    'VA': {
        name: 'Virginia',
        isoCode: 'VA'
    },
    'WA': {
        name: 'Washington',
        isoCode: 'WA'
    },
    'WV': {
        name: 'West Virginia',
        isoCode: 'WV'
    },
    'WI': {
        name: 'Wisconsin',
        isoCode: 'WI'
    },
    'WY': {
        name: 'Wyoming',
        isoCode: 'WY'
    }
};

export const getStateOptions = createLocationOptionsGetter(stateMap);

export default stateMap;